//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import cmFooter from '@/components/cmFooter.vue'
export default {
  name: 'factoryContractor',
  components: {
      cmFooter
  },
  data () {
    return {
      info:{
        yesterdayIn:'',
        todaySendWash:'',
        todayIn:'',
        todayOut:'',
        yesterdayData:{
          totalMoney:0.00
        },
        todayData:{
          totalMoney:0.00
        },
      },
        nav:[
          {
          title:'入厂',
          path:'/inFactory/0',
          auth:'inFactory',
          img:'/static/images/inFactory.png',
        },
         {
          title:'打包',
          path:'/inFactory/1',
          auth:'pack',
          img:'/static/images/pack.png',
        },
         {
          title:'出厂',
          path:'/inFactory/2',
          auth:'outMaxFactory',
          img:'/static/images/outMaxFactory.png',
        },
       
        {
          title:'不洗退回',
          path:'/factoryReturn',
          auth:'factoryReturn',
          img:'/static/images/factoryReturn.png',
        },
        {
          title:'异常报备',
          path:'/abnormal',
          auth:'abnormal',
          img:'/static/images/abnormal.png',
        },
        {
          title:'厂内返洗',
          path:'/factoryBack',
          auth:'factoryBack',
          img:'/static/images/factoryBack.png',
        },
        {
          title:'污渍终结',
          path:'/stainsEnd',
          auth:'stainsEnd',
          img:'/static/images/stainsEnd.png',
        },
      ],
      nav1:[
          {
          title:'录单统计',
          path:'/inFactoryData/0',
          auth:'inFactoryData',
          img:'/static/images/ludan.png',
        },
          {
          title:'入厂统计',
          path:'/inFactoryData/1',
          auth:'inFactoryData',
          img:'/static/images/dabao.png',
        },
          {
          title:'打包统计',
          path:'/inFactoryData/2',
          auth:'inFactoryData',
          img:'/static/images/inFactory.png',
        },
          {
          title:'出厂统计',
          path:'/inFactoryData/3',
          auth:'inFactoryData',
          img:'/static/images/outMaxFactory.png',
        },
         {
          title:'收益统计',
          path:'/factoryProfitData',
          auth:'factoryProfitData',
          img:'/static/images/searchOrder.png',
        },
         {
          title:'员工操作统计',
          path:'/inFactoryUserData',
          auth:'inFactoryUserData',
          img:'/static/images/ludan.png',
        },
        {
          title:'条码查询',
          path:'/barOrder',
          auth:'barOrder',
          img:'/static/images/bar.png',
        },
      ]
    }
  },
  created(){
    if(this.$func.getLocal('token')){
      this.getCount();
    }else{
      this.$router.push({path:'/login'})
    }
  },
  mounted(){
  },
  methods:{
    getCount(){
      this.$api.factoryDataContract({}).then((res)=>{
        this.info = res.data;
      })
    },
    showMsg(){
      let grade = parseInt(this.$func.getLocal('grade'));
      if(grade == 21){
        this.$func.showToast('按门店录单数据统计');
      }
      if(grade == 22){
        this.$func.showToast('按加工厂打包数据统计');
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/factoryContractor.vue